import React from "react";

export const useToggle = (initialState = false) => {
  const [isOpen, setIsOpen] = React.useState(initialState);
  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);
  const onToggle = () => setIsOpen(!isOpen);
  return { isOpen, onClose, onOpen, onToggle };
}